// extracted by mini-css-extract-plugin
module.exports = {"inlineAd":"sR","innerWrapper":"tR","tooltipWrapper":"uR","icon":"vR","tooltip":"wR","content":"xR"};